import type { LatLngBounds } from 'leaflet'

export async function fetchAvailableAreas(
  bounds: LatLngBounds
): Promise<AvailableAreasResponse> {
  return await $fetch<AvailableAreasResponse>('/availabilities/areas', {
    method: 'GET',
    baseURL: useRuntimeConfig().public.apiBaseURL,
    query: {
      upperLat: bounds.getNorthEast().lat,
      upperLon: bounds.getNorthEast().lng,
      lowerLat: bounds.getSouthWest().lat,
      lowerLon: bounds.getSouthWest().lng,
      areaTypes: ['OPERATIONAREA', 'NOPARKINGAREA'],
    },
  }).catch((error) => {
    return error.data
  })
}
